import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Reveal from "../common/Reveal";

// ── Photos — remplace par tes vraies images dans /public/assets/ ──

const photos = [
  "/assets/photo1.jpeg",
  "/assets/home.jpeg",
  "/assets/photo3.jpeg",
  "/assets/photo4.jpeg",
  "/assets/photo5.jpeg",
  "/assets/photo6.jpeg",
  "/assets/photo7.jpeg",
  "/assets/photo24.jpeg",
  "/assets/photo9.jpeg",
];

// ── Styled ────────────────────────────────────────────────────

const PageWrapper = styled(Box)({
  backgroundColor: "#f5f5f5",
  padding: "60px 20px",
  textAlign: "center",
});

const HeaderTitle = styled(Typography)({
  fontSize: "1.8rem",
  letterSpacing: "0.3em",
  textTransform: "uppercase",
  color: "#333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "16px",
});

const HeaderSubtext = styled(Typography)({
  color: "#888",
  fontSize: "0.85rem",
  maxWidth: "560px",
  margin: "0 auto 48px",
  lineHeight: 1.9,
});

const Grid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "12px",
  maxWidth: "820px",
  margin: "0 auto",
  "@media (max-width:820px)": { gridTemplateColumns: "repeat(2, 1fr)" },
});

const PhotoCard = styled(Box)({
  backgroundColor: "white",
  padding: "8px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  overflow: "hidden",
  cursor: "pointer",
  transition: "transform 0.4s cubic-bezier(0.16,1,0.3,1), box-shadow 0.4s ease",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 16px 34px rgba(0,0,0,0.16)",
  },
  "&:hover img": { transform: "scale(1.07)" },
});

const Photo = styled("img")({
  width: "100%",
  height: "200px",
  objectFit: "cover",
  display: "block",
  transition: "transform 0.3s ease",
});

// ── Composant ─────────────────────────────────────────────────

export default function Gallery() {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <HeaderTitle>
        {t("gallery.titlePre")} <span style={{ color: "#e53935" }}>♥</span>{" "}
        {t("gallery.titlePost")}
      </HeaderTitle>
      <HeaderSubtext>{t("gallery.subtext")}</HeaderSubtext>

      <Grid>
        {photos.map((src, i) => (
          <Reveal key={i} delay={(i % 3) * 120}>
            <PhotoCard>
              <Photo src={src} alt={`photo ${i + 1}`} />
            </PhotoCard>
          </Reveal>
        ))}
      </Grid>
    </PageWrapper>
  );
}
